import type { PropsWithChildren } from 'react';

import { Skeleton } from '@/_components';

import { StickyPageHeaderSkeleton } from './sticky-page-header-skeleton';

export function StickyPageHeaderSkeletonWithButtons({
  numberOfButtons = 2,
  ...rest
}: PropsWithChildren<{
  isModal?: boolean;
  allowBack?: boolean;
  numberOfButtons: number;
  withBreadcrumb?: boolean;
}>) {
  return (
    <StickyPageHeaderSkeleton {...rest}>
      <div className="flex gap-3">
        {Array.from(Array(numberOfButtons).keys()).map((i) => (
          <Skeleton className="h-8 w-28 rounded-xl" key={i} />
        ))}
      </div>
    </StickyPageHeaderSkeleton>
  );
}
